import React from 'react';
import LongText from '../../../Elements/LongText';
import TpPlatformInvoiceLineItem from './TpPlatformInvoiceLineItem';

// "Development" tab of the platform-invoice detail popup: Programming rows only — the
// platform sends a count of programming items and an amount.
export default class TpPlatformInvoiceDevelopmentItem extends TpPlatformInvoiceLineItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Billing Code',
        orderById: 'ThirdPartyBillingCode',
        data: 'ThirdPartyBillingCode',
        minWidth: 50,
      },
      {
        label: 'TP Client ID',
        orderById: 'ThirdPartyClientId',
        data: 'ThirdPartyClientId',
        className: 'text-center',
        minWidth: 40,
      },
      {
        label: 'Company',
        orderById: 'ThirdPartyCompany',
        data: (d) => (
          <LongText
            text={d.ThirdPartyCompany}
            maxLength={30}
          />
        ),
        className: 'text-left',
        minWidth: 80,
      },
      {
        label: 'Caspian Client',
        orderById: '',
        data: (item) => TpPlatformInvoiceLineItem.getCaspianClientCellContent(item),
        className: 'text-left',
        minWidth: 80,
      },
      {
        label: 'Office',
        orderById: '',
        data: 'OfficeName',
        className: 'text-left',
        minWidth: 50,
      },
      {
        label: 'Count',
        orderById: '',
        data: 'ThirdPartyItemCount',
        className: 'text-center',
        minWidth: 30,
      },
      {
        label: 'Amount',
        orderById: '',
        data: 'ThirdPartyAmount',
        className: 'text-right',
        minWidth: 40,
      },
    ];
  }
}
